import { render, staticRenderFns } from "./TopSection.vue?vue&type=template&id=270534ff&scoped=true&"
import script from "./TopSection.vue?vue&type=script&lang=js&"
export * from "./TopSection.vue?vue&type=script&lang=js&"
import style0 from "./TopSection.vue?vue&type=style&index=0&id=270534ff&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "270534ff",
  null
  
)

export default component.exports